import { render, staticRenderFns } from "./SchedulesConfig.vue?vue&type=template&id=b22cfe44&scoped=true"
import script from "./SchedulesConfig.vue?vue&type=script&lang=js"
export * from "./SchedulesConfig.vue?vue&type=script&lang=js"
import style0 from "./SchedulesConfig.vue?vue&type=style&index=0&id=b22cfe44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22cfe44",
  null
  
)

export default component.exports